import React from "react";
import "./VideoFeed.css";
import videoOne from "../../../Assets/Videos/Video-789.mp4";
import videoTwo from "../../../Assets/Videos/Video-42.mp4";
import videoThree from "../../../Assets/Videos/Video-198.mp4";
import videoFour from "../../../Assets/Videos/Video-345.mp4";
import videoFive from "../../../Assets/Videos/Video-277.mp4";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Button } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useState, useEffect, useRef } from "react";
import { findProducts } from "../../../Redux/Customers/Product/Action";
import { useDispatch, useSelector } from "react-redux";
import AliceCarousel from "react-alice-carousel";
import { ConsoleLine, TruckRemoveOutline } from "mdi-material-ui";

const HomeProductSection = ({ section, query, view_all }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const theme = useTheme();
  const matchesLG = useMediaQuery(theme.breakpoints.up("lg"));
  const matchesMD = useMediaQuery(theme.breakpoints.up("md"));


  // const slidePrev = () => setActiveIndex(activeIndex - 4);
  // const slideNext = () => setActiveIndex(activeIndex + 4);
  const carouselRef = useRef(null);

  const syncActiveIndex = ({ item }) => setActiveIndex(item);
  const handlePrevClick = () => {
    if (carouselRef.current) {
      carouselRef.current.slidePrev();
    }
  };

  const handleNextClick = () => {
    if (carouselRef.current) {
      carouselRef.current.slideNext();
    }
  };

  // setInterval(()=>{
  //   handleNextClick()
  // },3000)

  const items = [videoOne, videoTwo, videoThree, videoFour, videoFive];

  const infinteLoop = !(matchesLG && matchesMD);


  const responsive = {
    0: {
      items: 2,
      itemsFit: "contain",
    },
    568: {
      items: 3,
      itemsFit: "contain",
    },
    1024: {
      items: 5.5,
      itemsFit: "contain",
    },
  };

  return (
    <div className="relative px-4 lg:ml-11 lg:mr-11 sm:px-6 lg:px-8 text-center">
      <p className="font-normal mt-12 mb-5 text-center text-[#b28585] uppercase">
        Straight from <a href="https://www.instagram.com/aashapura_safa_barmer/" target="_blank">@aashapura_safa_barmer</a>
      </p>
      <h2 className="text-2xl font-extrabold mt-1 mb-3 text-center text-[#b28585]">
        {section}
      </h2>
      <div className="relative p-5">
        <AliceCarousel
          disableButtonsControls
          disableDotsControls
          mouseTracking
          items={items.slice(0, 10).map((item) => (
            <div className="">
              <div>
                <video
                  src={item}
                  muted
                  loop
                  autoPlay
                  className="instavideo"
                  // style="width: 19.5%; border-radius: 20px; padding: 10px"
                ></video>
              </div>
            </div>
          ))}
          activeIndex={activeIndex}
          responsive={responsive}
          onSlideChanged={syncActiveIndex}
          animationType="fadeout"
          // animationDuration={250}
          ref={carouselRef}
          autoPlayDirection="ltr"
          autoPlay={true}
          animationEasingFunction="ease"
          animationDuration={2000}
          infinite={infinteLoop}
        />
      </div>
    </div>
  );
};

export default HomeProductSection;
